module.exports = __webpack_public_path__ + "img/k12_room2.9be729d5.png";